import { startHandwriting } from "./handwriting-start.js";
import { startSearchSuggestions } from "./search-suggestions.js";

/**
 * The script the pages carrying a search box load.
 *
 * A bundle of its own rather than a few hundred bytes added to `site`, which
 * is what `script-bundles.ts` argues. The box is on the two archives and on
 * every entry and sentence page, and the home page, the articles and the tools
 * have none: folding this into the script every page loads would be bytes
 * those pages carry for a control they do not draw.
 *
 * `partials/search-form.html` is what loads it, so a page that draws the box
 * gets the script and a page that does not never asks for it. The tag is
 * `type="module"`, which defers, so the box has been parsed by the time this
 * runs.
 *
 * Nothing about the box needs it. See `search-suggestions.ts`.
 *
 * The pen beside the box is the second thing it starts. That button is drawn
 * hidden and shown here, so a page whose bundle never arrives shows a box and
 * no pen. See `handwriting-start.ts`.
 */
startSearchSuggestions(document);
startHandwriting(document);
